<app-banners secaoUrl="downloads"></app-banners>
<div>
  <div>
    <p class="title-pages title-pages__main-blues text-center"><span>Downloads</span></p>
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-lg-3 col-md-4 col-6 p-2 " *ngFor="let download of downloads; let i = index">
      <a href="{{download.arquivo}}" [target]="blank(download.arquivo) ? '_blank' : ''">
        <div class="borda">
          <img [src]="download.icone" alt="">
        </div>
        <div class="texto">
          <p class="download-titulo">{{download.nome}}</p>
          <p class="download-subtitulo">{{download.descricao}}</p>
        </div>
      </a>
    </div>
  </div>
</div>
